import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, Row, Col,
    FormGroup, Label, Input, Button
} from 'reactstrap';
import Select from 'react-select';
import { AuthContext } from '../../context/AuthContext';

import { TipoDespesasVendedorContext } from '../../context/TipoDespesasVendedorContext';
import { UpdateTipoDespesasVendedorType } from '../../context/hooks/useTipoDespesasVendedor';

import { CurrencyInput } from '../Form/CurrencyInput';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    tipoDespesasVendedor: UpdateTipoDespesasVendedorType | null;
    onUpdated?: () => void;
}

export const EditTipoDespesasVendedorModal: React.FC<Props> = ({ isOpen, toggle, tipoDespesasVendedor, onUpdated }) => {
    const { updateTipoDespesasVendedor } = useContext(TipoDespesasVendedorContext);
    const { objUserTk } = useContext(AuthContext);

    const [form, setForm] = useState<UpdateTipoDespesasVendedorType | null>(null);

    useEffect(() => {
        if (isOpen && tipoDespesasVendedor) setForm({ ...tipoDespesasVendedor });
    }, [isOpen, tipoDespesasVendedor]);

    if (!form) return null;

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setForm(prev => prev ? { ...prev, [name]: value } : prev);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!form) return;
        const ok = await updateTipoDespesasVendedor({
            ...form,
        });
        if (ok) {
            onUpdated?.();
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Editar informações do tipo</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Nome</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={onChange}
                                    placeholder="Nome"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">ÍCone</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="icon"
                                    value={form.icon || ''}
                                    onChange={onChange}
                                    placeholder="Ícone"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">Salvar alterações</Button>
                        <Button style={{ background: '#585858', color: '#fff' }} className="ml-2" onClick={toggle}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};
export default EditTipoDespesasVendedorModal;